import React from 'react';
import { Typography, Box } from '@mui/material';
import { NodonTheme } from '@client/style';
import { CommentRowBase } from './CommentRowBase';
import { User } from '@shared/models/user.model';
import { IComment } from '@shared/models/comment.model';

type CommentAsyncErrorProps = {
  user: User;
  comment: IComment;
};

/**
 * Loading row used when waiting for a response from the AI.
 * Tries to imitate a regular row but with a dot loader instead of a message.
 * @returns
 */
export const CommentAsyncError: React.FC<CommentAsyncErrorProps> = ({
  user,
}) => {
  return (
    <CommentRowBase
      user={user}
      rightContent={
        <Box>
          <Typography variant="body2" color={NodonTheme.palette.text.secondary}>
            Could not generate response
          </Typography>
        </Box>
      }
    />
  );
};
